const em = {
  mounted () {
    this.setFontSize()
    // 监听浏览器窗口变化
    window.addEventListener('resize', () => {
      this.$nextTick(() => {
        this.setFontSize()
      })
    })
  },
  methods: {
    setFontSize () {
      if (document.body.offsetWidth) {
        const res1 = (document.body.offsetWidth / this.fullWidth)
        const res2 = (document.body.offsetHeight / this.fullHeight)
        // const fontSize = (res==1?res)*24
        const style = {
          ...this.emStyle
        }

        if (document.body.offsetWidth / document.body.offsetHeight - 0.41 > this.fullWidth / this.fullHeight) {
          style.transform = `scale(${res2})`
        } else {
          style.transform = `scale(${res1})`
        }
        // style['transform'] = `scale(${(res==1?res:res-0.005)})`
        style.transformOrigin = 'left top'
        this.emStyle = style
      }
    }
  }
}
export default em
